import * as ACTION_TYPES from '../types';

let initialState = {
  taskList: [],
  task:{},
  taskList_by_query: []
}

export default (state = initialState, action) => {
    switch (action.type) {
      case ACTION_TYPES.ADD_TASKS:
        return action.task;
      case ACTION_TYPES.GET_TASKS:
        return {...state, taskList: action.data, totalItems: action.totalItems };
      case ACTION_TYPES.GET_TASKS_BY_ID:
        return {...state, taskList: action.data };

      case ACTION_TYPES.GET_TASKS_BY_EQUIPMENTNO:
        return {...state, taskList: action.data };
      case ACTION_TYPES.GET_TASKS_BY_SKNO:
        return {...state, taskList: action.data };
      // case ACTION_TYPES.GET_TASKS_BY_USER:
      //   return {...state, taskList: action.data };
      // case ACTION_TYPES.GET_TASKS_BY_TASKTYPE:
      //   return {...state, taskList: action.data };
      // case ACTION_TYPES.GET_TASKS_BY_STATE:
      //   return {...state, taskList: action.data };
      // case ACTION_TYPES.GET_TASKS_BY_DATE:
      //   return {...state, taskList: action.data };
      // case ACTION_TYPES.GET_TASKS_BY_SUPPORT:
      //   return {...state, taskList: action.data };

      case ACTION_TYPES.GET_TASK_BY_QUERY:
        return {...state, taskList: action.data };

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };
      case ACTION_TYPES.DONE:
        return {...state, loading: false };
      case ACTION_TYPES.RESET_TASKS:
        return {...state, taskList: []};
      default:
        return state;
    }
  };  


  